<template>
    <div>
        <Modal ref="alert-modal" :z-index="99999" class="distribution-alert-modal" :width="320" @on-visible-change="changeVisible" v-model="showModal" :title="title" :mask-closable="false">
            <template v-slot:header>
                <div class="modal-title">{{ title }}</div>
            </template>
            <div class="modal-content">
                {{ desc }}
            </div>
            <template v-slot:footer>
                <div class="modal-footer">
                    <Button class="modal-confirm" type="error" @click="submit" >{{ $t('global.common.update_OK', { defaultValue: '确定' }) }}</Button>
                </div>
            </template>
            <Spin v-if="loading" :fix="true"></Spin>
        </Modal>
    </div>
</template>
<script>
export default {
    props: ['show', 'title', 'desc', 'confirm', 'width'],
    data () {
        return {
            showModal: false,
            loading: false
        }
    },
    watch: {
        show: {
            immediate: true,
            handler (val) {
                this.showModal = val;
                this.loading = false;
            }
        }
    },
    methods: {
        changeVisible (val) {
            if (!val) this.$emit('on-alert-close');
            this.showModal = val;
        },
        submit () {
            this.loading = true;
            this.confirm();
        }
    }
}
</script>
<style lang="scss">
.distribution-alert-modal {
    .ivu-modal-header {
        padding: 15px 0;
    }
    .modal-content {
        text-align: center;
    }
    .modal-title {
        text-align: center;
        color: #ed4014;
        font-size: 16px;
    }
}
</style>
<style lang="scss" scoped>
    .modal-footer {
        width: 100%;
        // padding: 12px 18px;

        .modal-confirm {
            width: 100%;
        }
    }
</style>